import Cookies, { CookieAttributes } from "js-cookie";

export const setCookie = (name: string, content: string, options?: CookieAttributes | undefined) => {
	Cookies.set(`Scoreplan${name}`, content, options);
};

export const getCookie = (name: string) => Cookies.get(`Scoreplan${name}`);

export const removeCookie = (name: string) => {
	Cookies.remove(`Scoreplan${name}`);
};
